export default {
    locale_code: "pt-BR",
    sms: "SMS",
    rcs: "RCS",
    email: "E-mail",
    whatsapp: "WhatsApp",
    webhook: "Webhook",
    ia_basic: "IA Básico",
    ia_advanced: "IA Avançado",
    scheduled: "Agendado",
    sent: "Enviado",
    accepted: "Aceito",
    queued: "Processando",
    failed: "Falhou",
    text: "Texto",
    date: "Data",
    user: "Usuário",
    textarea: "Texto longo",
    number: "Número",
    coupon: "Cupom de desconto",
    checkbox: "Checkbox",
    currency_symbol: "R$",
    percent_symbol: "%",
    active: "Ativo",
    add: "Adicionar",
    archived: "Arquivado",
    back: "Voltar", 
    brand: "Marca",
    category: "Categoria",
    delete: "Excluir",
    fields: "Campos",
    no_results_found: "Nenhum resultado encontrado",
    options: "Opções",
    paused: "Pausado",
    price: "Preço", 
    product: "Produto",
    quantity_short: "Qtd",
    remove: "Remover",
    undo: "Desfazer",
    search: "Buscar",
    select: "Selecionar",
    total: "Total",
    type: "Tipo",
    unavailable: "Indisponível",
    value: "Valor",
    whatsapp_file_preview: "Visualizar arquivo do WhatsApp",
    username: "Nome de usuário", 
    plugin: "Plugin",
    two_factor_auth: "Autenticação de dois fatores",
    ces_score: "Pontuação CES",
    nps_score: "Pontuação NPS",
    valid_between: "Válido entre",
    days_ago: "Há {0} dias",
    today: "Hoje",
    tomorrow: "Amanhã",
    in_x_days: "Em {0} dias",
    yes: "Sim",
    no: "Não",
    outside_journey: "Fora da Jornada",
    whatsapp_official: "WhatsApp Oficial",
    kevi_title_prefix: "Kevi",
    error: "Erro",
    unknown: "Desconhecido",
    tasks: "Tarefas",
    "tasks-label": "Tarefas",
    support: "Suporte",
    dates: {
        month: "mês",
        week: "semana",
        day: "dia",
        year: "ano",
        week_day: "dia da semana",
        hour: "hora",
        Mon: "Seg",
        Tue: "Ter",
        Wed: "Qua",
        Thu: "Qui",
        Fri: "Sex",
        Sat: "Sab",
        Sun: "Dom",
        full_months: {
            "0": "janeiro",
            "1": "fevereiro",
            "2": "março",
            "3": "abril",
            "4": "maio",
            "5": "junho",
            "6": "julho",
            "7": "agosto",
            "8": "setembro",
            "9": "outubro",
            "10": "novembro",
            "11": "dezembro",
        },
        full_weekdays: [
            "domingo",
            "segunda-feira",
            "terça-feira",
            "quarta-feira",
            "quinta-feira",
            "sexta-feira",
            "sábado",
        ],
        default_format: "[d] de [MM] de [Y]",
        format_day_month_long: "[d] de [MM]",
        format_full_date: "[d] de [MM] de [YY]",
        format_day_month_short: "[d]/[M]",
        format_day_month_short_time: "[d]/[M] às [h]:[m]",
        format_date_2y: "[d]/[MM]/[Y]",
        format_date: "[d]/[M]/[Y]",
        format_date_time: "[d]/[M]/[Y] às [h]:[m]",
        format_date_time_seconds: "[d]/[M]/[Y] às [h]:[m]:[s]",
        format_date_time_weekday: "[d]/[M]/[Y] às [h]:[m] - [D]:ucf",
        format_date_weekday: "[d]/[M]/[Y] ([D])",
        format_date_time_simple: "[d]/[M]/[Y] [h]:[m]",
        format_date_time_comma: "[d]/[M]/[Y], [h]:[m]",
        format_date_4y: "[d]/[M]/[YY]",
        format_weekday_date: "[D]:ucf - [d]/[M]/[Y]",
        format_weekday_date_time: "[D]:ucf - [d]/[M]/[Y] às [h]:[m]",
        format_time: "[h]:[m]",
        format_month_year: "[MM]/[YY]",
        format_year: "[YY]",
        month_names: {
            "0": "Janeiro",
            "1": "Fevereiro", 
            "2": "Março",
            "3": "Abril",
            "4": "Maio",
            "5": "Junho",
            "6": "Julho",
            "7": "Agosto",
            "8": "Setembro",
            "9": "Outubro",
            "10": "Novembro",
            "11": "Dezembro"
        }
    },
    inputs: {
        datepicker: {
            month: "Mês",
            year: "Ano",
            time: "Horário:",
            hour_placeholder: "HH",
            minute_placeholder: "MM",
            now: "Agora",
            today: "Hoje",
            clear: "Limpar",
            confirm: "Confirmar",
            weekdays: {
                sun: "Dom",
                mon: "Seg",
                tue: "Ter",
                wed: "Qua",
                thu: "Qui",
                fri: "Sex",
                sat: "Sáb",
            },
        },
    },
    rfm_groups: {
        cant_lose: "Não pode perder",
        champion: "Campeões",
        loyal: "Leais",
        needs_attention: "Precisam de atenção",
        potential_champion: "Potenciais leais",
        new: "Novos",
        promising: "Promissores",
        about_to_sleep: "Prestes a dormir",
        at_risk: "Em risco",
        hibernating: "Hibernando",
        lost: "Perdidos",
    },
    sender_options: {
        token: "Token",
        from: "De",
        from_name: "Nome do remetente",
        from_email: "E-mail do remetente",
        from_phone: "Telefone do remetente",
        whatsapp_business_id: "ID do WhatsApp Business",
        phone_number_id: "ID do número de telefone",
        domain: "Domínio",
        account_token: "Token de conta",
        access_token: "Token de acesso",
        refresh_token: "Token de atualização",
        api_key: "Chave de API",
        channel_id: "ID do canal",
        client_id: "ID do cliente",
        secret_id: "Segredo do cliente",
        email: "E-mail",
        password: "Senha",
        slug: "Slug",
        id: "ID",
        instance_token: "Token de instância",
        instance_code: "Código de instância",
        instance_id: "ID da instância",
        subdomain: "Subdomínio",
        api_access_token: "Token de acesso da API",
        account_id: "ID da conta",
        inbox_id: "ID da caixa de entrada",
        chatwoot_url: "URL do Chatwoot",
        meta_access_token: "Token de acesso Meta",
        base_url: "URL Base",
    },
    filter_bar: {
        add_filter: "Adicionar Filtro",
        select_filter: "Selecione um filtro",
        clear_filter: "Limpar filtro",
        period: "Período",
        branches: "Filiais",
        client: "Cliente",
        form: "Formulário",
        avg_ticket: "Ticket médio",
        orders_amount: "Número de pedidos",
        customer_profile: "Perfil do cliente",
        with_complete_registration: "Com cadastro completo",
        without_complete_registration: "Sem cadastro completo",
        points_balance: "Saldo de Pontos",
        client_segments: "Segmento do cliente",
        client_segments_not: "Não está no segmento",
        last_order_period: "Período do último pedido",
        min_period_between_executions: "Tempo mínimo entre execuções",
        last_order_branch: "Filial do último pedido",
        clients_limit: "Limite de clientes",
        value: "Valor",
        automation_title: "Título da automação",
        type: "Tipo",
        campaigns: "Campanhas",
        automations: "Automações",
        status: "Status",
        active: "Ativas",
        paused: "Pausadas",
        deleted: "Deletadas",
        first_order_period: "Período do primeiro pedido",
        order_status: "Status do Pedido",
        file_type: "Tipo de Arquivo",
        file_preview: "Pré-visualização do arquivo",
        whatsapp_file_preview: "Pré-visualização do arquivo WhatsApp",
        image: "Imagem",
        pdf: "PDF",
        video: "Vídeo",
        audio: "Áudio",
        other: "Outro",
        purchased_in_period: "Comprou no período",
        registration_date: "Data de cadastro",
        name_phone_email_or_code: "Nome, telefone, e-mail ou código",
        coupon_code: "Código do cupom",
        expiration_date: "Data de validade",
        usage_date: "Data de uso",
        automation: "Automação",
        situation: "Situação",
        available: "Disponível",
        used: "Utilizado",
        expired: "Vencido",
        accepted: "Aceita",
        scheduled: "Agendada",
        sent: "Enviada",
        failed: "Falha",
        processing: "Processando",
        method: "Método",
        quotation_status: "Status do Orçamento",
        responsible: "Responsável",
        task_deadline: "Prazo da tarefa",
        creation_date: "Data de criação",
        completion_date: "Data de conclusão",
        pending: "Pendentes",
        completed: "Completas",
        archived: "Arquivadas",
        quotations_amount: "Número de orçamentos",
        quotations_value: "Valor de orçamentos",
        rfm_group: "Grupo RFM",
        campaign_interactions: "Interações de Campanha",
        days_after: "Dias após ",
        custom_event: "Evento Personalizado",
        purchased_product: "Comprou produto",
        with_phone: "Com telefone",
        with_email: "Com e-mail",
        accumulated_spending_clv: "Gasto acumulado (CLV)",
        days_since_last_order: "Dias desde o último pedido",
        days_since_first_order: "Dias desde o primeiro pedido",
        predicted_days_until_next_order: "Dias previstos até próximo pedido",
        days_since_registration: "Dias desde o cadastro",
        age: "Idade",
        month_birthday: "Aniversariantes do Mês",
        communication_channels: "Canais de Comunicação",
    },
    user_notifications: {
        edited_task: "{$0} editou a tarefa {$1}",
        commented_on_task: "{$0} comentou na tarefa {$1}",
        completed_task: "{$0} completou a tarefa {$1}",
        archived_task: "{$0} arquivou a tarefa {$1}",
        moved_task_to_column: "{$0} moveu a tarefa {$1} para a coluna {$2}",
        mentioned_you_in_a_task: "{$0} te mencionou em uma tarefa",
        mentioned_you_in_a_task_comment: "{$0} te mencionou em um comentário de tarefa",
        your_task_is_overdue_by_days: "Sua tarefa {$0} está atrasada há {$1} dias!",
        you_have_overdue_tasks: "Você tem {$0} tarefas atrasadas.",
        beta_admin_only: "Beta: Disponível só para administradores",
        no_notifications: "Nenhuma notificação",
        mark_all_read: "Marcar todas como lidas",
    },
    searchSelect: {
        placeholder: "Buscar...",
        client_placeholder: "Buscar cliente...",
        clear: "Limpar",
        loading: "Buscando...",
        empty: "Nenhum resultado encontrado",
        hint: "Digite pelo menos {0} caracter para buscar",
        close: "Fechar",
    },
    confirm_phrase: {
        instruction: "Digite a seguinte frase para confirmar a ação:",
        placeholder: "Digite a frase de confirmação aqui",
    },
    info_modal: {
        close: "Fechar",
    },
    kv_search_select: {
        loading: "Buscando...",
        empty: "Nenhum resultado encontrado",
        hint: "Digite pelo menos {$0} caracter para buscar",
        close: "Fechar",
        clear: "Limpar",
        placeholder: "Buscar...",
    },
    clients_field: {
        placeholder: "Buscar cliente",
        aria_label: "Buscar cliente",
    },
    filter_group: {
        and_all: "E (todos os filtros)",
        or_any: "OU (qualquer filtro)",
        not_exclude: "NÃO (excluir)",
        add_filter: "Adicionar Filtro",
        add_group: "Adicionar Grupo",
        no_filters: "Nenhum filtro disponível",
        empty_state: "Adicione filtros ou grupos para criar sua condição",
        remove_filter: "Remover filtro",
    },
    charts: {
        totals: "Totais",
    },
    code_editor: {
        placeholder: "Cole seu código aqui...",
        cancel: "Cancelar",
        save: "Salvar",
    },
    confirm: {
        cancel: "Cancelar",
        confirm: "Confirmar",
        close: "Fechar",
    },
    editor: {
        bold: "Negrito",
        italic: "Itálico", 
        underline: "Sublinhado",
        strikethrough: "Riscado",
        heading1: "Título 1",
        heading2: "Título 2", 
        bullet_list: "Lista",
        numbered_list: "Lista numerada",
        undo: "Desfazer",
        redo: "Refazer",
        link: "Link",
        body_font: "(Fonte do corpo)",
        line_height: "Altura da linha",
    },
    custom_fields: {
        not_informed: "Não informado",
        not_found: "Não encontrado",
        select_user: "Selecione o usuário",
    },
    custom_image: {
        change: "Trocar",
        get_from_computer: "Obter do computador",
        clean: "Limpar",
    },
    datetime: {
        clear_date: "Limpar data",
    },
    copy_button: {
        copy: "Copiar",
        copied: "Copiado!",
        copy_failed: "Falha ao copiar:",
    },
    grapejs: {
        blocks: {
            sect100: "1 Coluna",
            sect50: "2 Colunas",
            sect30: "3 Colunas",
            sect37: "2 Colunas",
            button: "Botão",
            divider: "Divisor",
            text: "Texto",
            "text-sect": "Seção de Texto",
            image: "Imagem",
            quote: "Cita",
            grid_items: "Grid",
            list_items: "Lista",
            link: "Link",
            link_block: "Bloco de Link",
        },
        save_email: "Salvar e-mail",
        save: "salvar",
        cancel: "cancelar",
        edit_menu: "Menu de Edição",
        tokens: "Tokens:",
    },
    inputs: {
        keyvalue: {
            field: "Campo",
            value: "Valor",
            placeholder_key: "Ex: nome",
            placeholder_value: "Ex: nome",
            placeholder_value_template: "Ex: [[cliente.nome]]",
            add_field: "Adicionar campo",
        },
        datepicker: {
            month: "Mês",
            year: "Ano",
            time: "Horário:",
            hour_placeholder: "HH",
            minute_placeholder: "MM",
            now: "Agora",
            today: "Hoje",
            clear: "Limpar",
            confirm: "Confirmar",
            weekdays: {
                sun: "Dom",
                mon: "Seg",
                tue: "Ter",
                wed: "Qua",
                thu: "Qui",
                fri: "Sex",
                sat: "Sáb",
            },
        },
        color: {
            title: "Cor",
            open: "Abrir seletor de cor",
            hex: "#000000",
            basics: "Básicas",
            hue: "Matiz",
            saturation_brightness: "Saturação e brilho",
            saturation_brightness_value: "Saturação {0}%, brilho {1}%",
        },
        image: {
            title: "Enviar imagem",
            description: "Arraste e solte ou selecione um arquivo JPG ou PNG.",
            button: "Selecionar arquivo",
            delete: "Remover imagem",
            defaultName: "Imagem",
            success: "Upload concluído com sucesso!",
            deleted: "Imagem removida com sucesso!",
            deleteModalTitle: "Remover imagem",
            deleteModalDescription: "Tem certeza de que deseja remover esta imagem?",
            deleteModalCancel: "Cancelar",
            deleteModalConfirm: "Remover",
            statusCompleted: "Concluído",
            statusUploading: "Enviando...",
            statusError: "Erro no upload",
            oversized: "O tamanho máximo por imagem é {0}MB. As seguintes imagens excederam o limite: {1}",
            parseError: "Erro ao interpretar a resposta do servidor.",
            serverError: "Ocorreu um erro no servidor ao enviar as imagens.",
            httpError: "Erro {0} ao realizar o upload.",
            networkError: "Erro de rede. Verifique sua conexão com a internet.",
        },
        daterangepicker: {
            today: "Hoje",
            yesterday: "Ontem",
            this_month: "Esse mês",
            this_year: "Esse ano",
            last_month: "Mês passado",
            last_year: "Ano passado",
            all_period: "Todo período",
            cancel: "Cancelar",
            apply: "Aplicar",
        },
        editor: {
            bold: "Negrito",
            italic: "Itálico",
            underline: "Sublinhado",
            strike: "Riscado",
            h1: "Título 1",
            h2: "Título 2",
            list: "Lista",
            ordered_list: "Lista numerada",
            undo: "Desfazer",
            redo: "Refazer",
            placeholder: "Digite aqui...",
        },
        validation: {
            invalid_value: "Valor inválido",
            validation_error: "Erro na validação",
        },
        select: {
            loading: "Carregando...",
            placeholder: "Selecione...",
            search_placeholder: "Buscar...",
            empty_text: "Nenhuma opção encontrada",
        },
    },
    reports: {
        filter_name: "Nome do filtro",
        template_unavailable: "Template indisponível",
        video_tag_not_supported: "Seu navegador não suporta a tag de vídeo.",
    },
    min: "Min",
    max: "Max",
    image: "Imagem",
    double_click_to_add_image: "Clique duas vezes para adicionar uma imagem",
    visual_editor: {
        alignment: "Alinhamento",
        left: "Esquerda",
        center: "Centro",
        right: "Direita",
        aspect_ratio: "Proporção",
        auto: "Auto",
        automatic: "Automático",
        drag_block: "Arrastar bloco",
        duplicate: "Duplicar",
        delete: "Excluir",
        border: "Borda",
        solid: "Sólida",
        dashed: "Tracejada",
        dotted: "Pontilhada",
        spacing: "Espaçamento",
        top: "Superior",
        bottom: "Inferior",
        custom_settings: "Configurações personalizadas",
        display: "Exibição",
        block: "Bloco",
        inline: "Em linha",
        drag_row: "Arrastar linha",
        drag_blocks_here: "Arraste blocos aqui",
        no_settings: "Nenhuma configuração encontrada.",
        vertical: "Vertical",
        horizontal: "Horizontal",
        back_to_simple_mode: "Voltar para modo simples",
        vertical_alignment: "Alinhamento vertical",
        middle: "Meio",
        width_unit: "Unidade de largura",
        percent: "Porcentagem",
        fixed_pixels: "Pixels fixos",
    },
    cancel: "Cancelar",
    apply: "Aplicar",
    save: "Salvar",
    edit: "Editar",
    actions: "Ações",
    status: "Status",
    id: "Id",
    name: "Nome",
    phone: "Telefone",
    title: "Título",
    all: "Todos",
    loading: "Carregando...",
    yes: "Sim",
    no: "Não",
    external_id: "Id externo",
    internal_server_error: "Erro Interno no Servidor, tente novamente mais tarde.",
    export: "Exportar",
    expiration_date: "Data de Expiração",
    client: "Cliente",
    places: {
        details: {
            access_denied: "Acesso negado",
            view_as: "Visualizar como {name}",
            manage_plan: "Gerenciar Plano",
            block: "Bloquear",
            activate: "Ativar",
            automations_locked: "Automações {status}",
            place_blocked: "Estabelecimento bloqueado",
            place_activated: "Estabelecimento liberado",
            automations_on: "ativadas",
            automations_off: "desactivated",
            activate_automations: "Ativar automações",
            deactivate_automations: "Desativar automações",
        },
        branches: {
            title: "Filiais",
            neighborhood_city: "Bairro / Cidade",
            add_branch: "Adicionar Filial",
        },
        modules: {
            title: "Módulos",
            updated: "Módulos atualizados!",
        },
        plugins: {
            title: "Plugins",
            add_plugin: "Adicionar Plugin",
            choose_plugin: "Escolher Plugin",
            external_id: "Id Externo",
            created_at: "Criado em",
            settings_updated: "Configurações atualizadas",
        },
        roles: {
            title: "Cargos",
            new_role_placeholder: "Novo cargo",
            role_added: "Cargo adicionado",
            role_updated: "Cargo atualizado",
            role_deleted: "Cargo Deletado",
        },
        users: {
            title: "Usuários",
            add_user: "Adicionar Usuário",
            active: "Ativo",
        },
    },
    quotations: {
        report_title: "Relatório de Orçamentos",
        budget_and_billing_by: "Orçamento e Faturamento por",
        group_by: "Agrupar por:",
        billing: "Faturamento",
        budget: "Orçamento",
        sent: "Orçamentos Enviados",
        clients: "Clientes",
        average_ticket: "Ticket Médio",
        awaiting_approval: "Aguardando Aprovação",
        approved: "Orçamentos Aprovados",
        rejected: "Orçamentos Recusados",
    },
    inbox: {
        filters: {
            select_status: "Selecione os status",
            new: "Novo",
            pending: "Pendente",
            solved: "Resolvido",
        },
    },
    segments: {
        filters: {
            birthdays_of_month: "Aniversariantes do mês",
            period_label: "Período: {period} dias atrás.",
            limit_time_range: "Limitar intervalo de tempo",
            days_ago: "Dias atrás",
            inform_values: "Informe os valores",
            until: "Até",
            from: "A partir de",
            between: "Entre",
            and: "e",
            more_than: "Mais de",
            select_values: "Selecione os valores",
            indifferent: "Indiferente",
            accepted: "Aceita",
            not_accepted: "Não aceita",
            event: "Evento",
            executions: "execuções",
            which_event: "Qual evento?",
            search_event: "Buscar evento...",
            limit_by_values: "Limitar por valores",
            search_combined_info: "A busca considera apenas os campos informados, sempre combinados",
            which_product: "Qual produto?",
            which_category: "Qual categoria?",
            which_brand: "Qual marca?",
            purchase_quantity: "Quantidade de compras",
            purchases: "compras",
            which_status_to_execute: "Em qual status executar?",
        },
    },
    settings: {
        journey: {
            title: "Jornada do cliente",
            stages: "Etapas",
            insert_first_stage: "Insira a primeira etapa",
            insert_first_substage: "Insira a primeira sub-etapa",
            board_renamed: "Quadro renomeado",
            board_prefix: "Quadro",
            add_stage_placeholder: "Adicionar etapa...",
            order_saved: "Ordem salva",
            stage_renamed: "Etapa renomeada",
        },
        plugins: {
            title: "Disparadores",
            sender: "Disparador",
            monthly_value: "Valor mensal",
            cost_per_message: "Custo por mensagem",
            credits: "créditos",
            none_registered: "Nenhum disparador cadastrado",
            edit_sender: "Editar disparador {name}",
            register_sender: "Cadastrar disparador",
            soon: "Em breve",
            send_test_to: "Enviar teste para:",
            save_changes: "Salvar alterações",
            add_sender: "Adicionar Disparador",
            sender_saved_test_sent: "Disparador salvo, teste enviado",
        },
        products: {
            title: "Produtos",
            no_images: "Sem imagens",
            cost: "Custo",
            brand: "Marca",
            stock: "Estoque",
            external_id: "ID Externo",
            orders_12m: "Pedidos (12m)",
            revenue_12m: "Receita (12m)",
            current_price: "Preço atual",
            last_purchase: "Última compra",
            purchase_history: "Histórico de Compras",
            bought_together: "Comprados Juntos",
            also_bought: "Também Compraram",
            ai: "IA",
            manual: "Manual",
            last_10_orders_including_product: "Últimos 10 pedidos que incluem este produto.",
            price_unit: "Preço Unit.",
            bought_in_same_order: "Produtos que foram comprados no mesmo pedido que este. Baseado nos últimos 90 dias de vendas.",
            clients_who_bought_also_bought: "Produtos que clientes que compraram este também compraram em outros pedidos. Baseado nos últimos 90 dias.",
            ai_recommendation_disclaimer: "Recomendação por IA: essas opções não são salvas no produto. Em vez disso, cada automação decide quando e como fazer o “match” por IA.",
            ai_placeholder: "Quem comprou X também pode gostar de...",
            use_ai: "Usar IA",
            manual_recommendation_disclaimer: "Adicione produtos relacionados rapidamente. Depois, se quiser, você pode incluir uma recomendação (motivo) para cada vínculo.",
            search_product_to_link: "Buscar produto para vincular...",
            added_products: "Produtos adicionados",
            no_manual_links: "Nenhum produto manual vinculado ainda.",
            add_recommendation_optional: "Adicionar recomendação (opcional)",
            link_removed: "Vínculo removido",
            product_linked: "Produto vinculado",
            recommendation_saved: "Recomendação salva",
            product_not_found: "Produto não encontrado.",
            manage_groups: "Gerenciar grupos",
            add_to_group: "Adicionar ao grupo",
            remove_from_group: "Remover do grupo",
            new_group: "Novo grupo",
            group_name: "Nome do grupo",
            batch_edit: "Editar em lote",
            repurchase_days: "Dias para recompra",
            group: "Agrupar",
            groups: "Grupos",
            products_updated: "Produtos atualizados",
            group_updated: "Grupo atualizado",
            something_went_wrong: "Ops, algo deu errado",
        },
        translations: {
            title: "Traduções",
            description: "Edite traduções por categoria e idioma. As alterações são salvas ao sair do campo.",
            locale: "Idioma",
            no_categories_found: "Nenhuma categoria de tradução encontrada.",
            items_for: "item(ns) para",
            no_translations_found: "Nenhuma tradução encontrada nesta categoria.",
            key: "Chave",
            original_en: "Original (EN)",
            translated: "Traduzido",
            saving: "Salvando...",
            saved: "Salvo",
            error_saving: "Erro ao salvar",
            unable_to_load: "Não foi possível carregar as traduções",
            unable_to_load_items: "Não foi possível carregar os itens da categoria",
        },
    },
    smart_insertion: {
        title: "Inserções Inteligentes",
        register_space: "Cadastrar Espaço",
        name_id: "Nome (id)",
        short_text: "Texto Curto",
        long_text: "Texto Longo",
        html: "HTML",
        add_field: "Adicionar Campo",
        required: "Requerido",
    },
};
